import toastr from 'toastr';

toastr.options.positionClass = "toast-top-right";
toastr.options.newestOnTop = true;
toastr.options.preventDuplicates = true;
toastr.options.closeButton = true;
toastr.options.timeOut = 0;
toastr.options.extendedTimeOut = 0;

export default toastr;



// WEBPACK FOOTER //
// ./app/general/js/toastr.js